import zIndex from '@mui/material/styles/zIndex';
import React, { useState, useMemo , useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import SearchImg from "../../../Assets/AppComponent/Arrow/Layer_1@2x.png";
import _ from "lodash";
import { ShimmerTable } from "react-shimmer-effects";
import {settheAdvanceEmployeeDatasHold} from "../../../Redux/Slice"

const AdvanceEmployee = (props) => {
    const {
        setdtPageindex, dtpageindex,

        employeesearch,
        setempsearch,
        range, 
        datas,
        datefilter,
        filterForWhite
    } = props;
    const dashboardData = useSelector((state) => state.EmployeeOfAdvanceAttendanceRecordsCall.EmployeeOfAdvanceAttendanceRecordsData);
    const [goPage, setGoPage] = useState(1);
    const state = useSelector((state) => state);
     const dispatch = useDispatch();
    const [sno, setsno] = useState(0);
    const tableHeaderStyle = {
        padding: "10px",
        fontWeight: "500",
        background: "#234492",
        // position: "sticky",
        // top: 0,
        color: "#fff",
        // zIndex: 2
    };


    const tableHeaderStyleFirst = {
        padding: "10px",
        fontWeight: "500",
        background: "#234492",
        // position: "sticky",
        // top: 0,
        color: "#fff",
        // zIndex: 2,
        borderRadius: "10px 0px 0px 10px"

    };

    const tableHeaderStyleLast = {
        padding: "10px",
        fontWeight: "500",
        background: "#234492",
        // position: "sticky",
        // top: 0,
        color: "#fff",
        // zIndex: 2,
        borderRadius: "0px 10px 10px 0px"

    };

    const tableCellStyle = {
        padding: "10px",
        borderBottom: "1px solid #ccc",
        fontSize: "12px",
        textAlign: "left"
    };
    const tableCellStyleno = {
        padding: "10px",
        borderBottom: "1px solid #ccc",
        fontSize: "12px",
        textAlign: "center"
    };
    const handleNext = (next) => {
        setdtPageindex(next + 1);
        if (range.length > 0 && !range.includes("NaN-aN-aN")) {

            const payload = {
                state: datas.state,
                region: datas.region,
                zone: datas.zone,
                from_date: range[0],
                to_date: range[1],
                range: datefilter.range,
                white_collar: filterForWhite.white_collar,
                page: next + 1,
                page_size: "10",
                search: employeesearch
            }
            dispatch(settheAdvanceEmployeeDatasHold(payload))
        }
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage)
        if (range.length > 0 && !range.includes("NaN-aN-aN")) {

            const payload = {
                state: datas.state,
                region: datas.region,
                zone: datas.zone,
                from_date: range[0],
                to_date: range[1],
                range: datefilter.range,
                white_collar: filterForWhite.white_collar,
                page: gotopage,
                page_size: "10",
                search: employeesearch
            }
            dispatch(settheAdvanceEmployeeDatasHold(payload))
        }
    }

    const handlePrevious = (previous) => {
        if (previous != 0) {
            setdtPageindex(previous);
            if (range.length > 0 && !range.includes("NaN-aN-aN")) {

                const payload = {
                    state: datas.state,
                    region: datas.region,
                    zone: datas.zone,
                    from_date: range[0],
                    to_date: range[1],
                    range: datefilter.range,
                    white_collar: filterForWhite.white_collar,
                    page: previous,
                    page_size: "10",
                    search: employeesearch
                }
                dispatch(settheAdvanceEmployeeDatasHold(payload))
            }

        }
    };

    const GotoThePage = () => {
        const goPageNumber = Number(goPage);

        if (
            Math.ceil(
                state.EmployeeOfAdvanceAttendanceRecordsCall.Total_Count == null ? 1 : state.EmployeeOfAdvanceAttendanceRecordsCall.Total_Count / 10
            ) >= goPageNumber ||
            goPageNumber == ""
        ) {
            setsno((goPageNumber - 1) * 10);

            GotoEnteredPage(goPageNumber);
        } else {
            toast.error("Invalid Page Number", {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };
    const formatTime = (timestamp) => {
        if (!timestamp) return ""; // Handle empty or undefined values

        const date = new Date(timestamp);
        let hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";

        hours = hours % 12 || 12; // Convert 24-hour format to 12-hour format

        return `${hours}:${minutes}`;
    };

    const calculateDuration = (checkIn, checkOut) => {
        if (!checkIn || !checkOut) return "--"; // Handle missing values

        const start = new Date(checkIn);
        const end = new Date(checkOut);
        const diffMs = end - start; // Difference in milliseconds

        if (diffMs <= 0) return "--"; // Handle invalid durations

        const hours = Math.floor(diffMs / (1000 * 60 * 60));
        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

        return `${hours}h ${minutes}m`;
    };
    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {

                setempsearch(e);
                if (range.length > 0 && !range.includes("NaN-aN-aN")) {

                    const payload = {
                        state: datas.state,
                        region: datas.region,
                        zone: datas.zone,
                        from_date: range[0],
                        to_date: range[1],
                        range: datefilter.range,
                        white_collar: filterForWhite.white_collar,
                        page:  1,
                        page_size: "10",
                        search: e
                    }
                    dispatch(settheAdvanceEmployeeDatasHold(payload))
                }
            }, 500),
        []
    );

    // -----Search------------------------
    function tochange(e) {
        setdtPageindex(1);
        debouncedSearch(e.target.value);
    }

    React.useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);



    return (
        <>

            <>
                <div style={{ background: "#fff", display: "flex", width: "100%", flexDirection: "column", gap: '10px', padding: "19px", borderRadius: "8px", marginBottom:"30px"}}>

                    <div className='AdvanceEmployeeListSearch'>
                        <span
                            class="border-0  bg-transparent "
                            id="search-addonAdvanca"
                        >
                            <img
                                src={SearchImg}
                                width="100%"
                                height="100%"
                            />
                        </span>
                        <input type='text'
                            onChange={tochange} />
                    </div>
                    <div className="NormalTableCalls" style={{ height: "437px", overflowY: "auto", overflowX: "auto", width: "100%", background: "#fff", paddingRight: "12px" }}>
                        <table className="TicketingTableOverviewsDashboard EmployeeTableOverviewsDashboard" style={{ width: "100%", borderCollapse: "collapse", textAlign: "center", minWidth: "1000px" }}>
                            <thead >
                                <tr>
                                    <th style={tableHeaderStyleFirst}>S.NO</th> {/* Header for FilterName */}
                                    <th style={tableHeaderStyle}>Date</th>
                                    <th style={tableHeaderStyle}>Client Name</th>
                                    <th style={tableHeaderStyle}>Employee Code</th>
                                    <th style={tableHeaderStyle}>Employee Name</th>
                                    <th style={tableHeaderStyle}>Check In</th>
                                    <th style={tableHeaderStyle}>Check Out</th>
                                    <th style={tableHeaderStyleLast}>Duration</th>
                                    {/* <th style={tableHeaderStyleLast}>Status</th> */}



                                </tr>
                            </thead>





                            {state.EmployeeVerificationsNeed.advance_attendanceloader ?
                                <>
                                    <tbody className="tbodyReact">

                                        <div className="TableLoader"
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                width: "100%", // Ensures it spans the full table width
                                                transform: "translate(-50%, -50%)",
                                            }}

                                        >
                                            <ShimmerTable
                                                row={2}
                                                col={9}
                                                style={{
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                }}
                                            />
                                        </div>
                                    </tbody>
                                </>
                                :

                                <>


                                    {dashboardData.length > 0 ?
                                        <tbody>
                                            {dashboardData.map((item, index) => (
                                                <tr key={index} style={{ borderBottom: "1px solid #ccc" }}>
                                                    <td style={tableCellStyle} className="LabelNamesstate">{Number(sno + index + 1)}</td>
                                                    <td style={tableCellStyle}> {`${item.created_at.slice(0, 10)}`}</td>
                                                    <td style={tableCellStyle}>{item.client_name || "--"}</td>
                                                    <td style={tableCellStyle}>{item.user_uid || "--"}</td>
                                                    <td style={tableCellStyle}>{item.first_name}</td>
                                                    <td style={tableCellStyle}>{item.check_in_time ? formatTime(item.check_in_time) : "--"}</td>
                                                    <td style={tableCellStyle}>{item.check_out_time ? formatTime(item.check_out_time) : "--"}</td>
                                                    <td style={tableCellStyle}>{item.check_in_time && item.check_out_time ? calculateDuration(item.check_in_time, item.check_out_time) : "--"}</td>
                                                    {/* <td style={tableCellStyle}>{"status"}</td> */}

                                                </tr>
                                            ))}
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr key={0} style={{ borderBottom: "1px solid #ccc" }}>
                                                <td colSpan="9" style={tableCellStyleno}>{"No data Available"}</td>
                                            </tr>
                                        </tbody>
                                    }                         </>
                            }

                        </table>

                    </div>

                    {state.EmployeeOfAdvanceAttendanceRecordsCall.Total_Count > 10 ? (
                        <div
                            className="pagination"
                            style={{ justifyContent: "end", width: "100%", height: "30px" }}
                        >
                            <div
                                className=" pagination"
                                style={{ justifyContent: "end" }}
                            >
                                <div className="showrow1" style={{ padding: "4px" }}>

                                    <button
                                        className="btn btn prim"
                                        style={{ border: "none" }}
                                        onClick={() => {
                                            handlePrevious(dtpageindex - 1);
                                            setsno(sno - 10);
                                        }}
                                        disabled={dtpageindex == 1}
                                    >
                                        {"<"}
                                    </button>
                                    <span style={{ padding: "10px" }}>
                                        <strong style={{ fontSize: "12px" }}>

                                            {dtpageindex} of{" "}
                                            {Math.ceil(
                                                state.EmployeeOfAdvanceAttendanceRecordsCall.Total_Count == null
                                                    ? 1
                                                    : state.EmployeeOfAdvanceAttendanceRecordsCall.Total_Count / 10
                                            )}{" "}
                                        </strong>
                                    </span>

                                    <button
                                        style={{ border: "none" }}
                                        className="btn btn prim"
                                        onClick={() => {
                                            handleNext(dtpageindex);

                                            setsno(sno + 10);
                                        }}
                                        disabled={
                                            dtpageindex ==
                                            Math.ceil(state.EmployeeOfAdvanceAttendanceRecordsCall.Total_Count / 10)
                                        }
                                    >
                                        {">"}
                                    </button>

                                    <span className="GOTOPageOuters">
                                        <form
                                            className="GotoPageForm"
                                            onSubmit={(e) => e.preventDefault()}
                                        >
                                            <span className="GotoPageText">Go to Page</span>
                                            <input
                                                type="number"
                                                value={goPage}
                                                className="formcontrol_Table"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const newPageIndex = e.target.value;
                                                    if (!isNaN(newPageIndex)) {
                                                        if (
                                                            newPageIndex != 0 &&
                                                            newPageIndex > 0
                                                        ) {
                                                            setGoPage(newPageIndex);
                                                        } else if (
                                                            newPageIndex == 0 ||
                                                            newPageIndex < 0
                                                        ) {
                                                            setGoPage("");
                                                        }
                                                    }
                                                }}
                                                step="1"
                                                onKeyDown={(evt) => {
                                                    if (
                                                        ["e", "E", "+", "-", "."].includes(
                                                            evt.key
                                                        )
                                                    ) {
                                                        evt.preventDefault();
                                                    }
                                                }}
                                            />

                                            <button
                                                type="submit"
                                                className="GOBTON btn"
                                                disabled={goPage == ""}
                                                onClick={(e) => {
                                                    GotoThePage();
                                                }}
                                            >
                                                Go
                                            </button>
                                        </form>
                                    </span>
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}


                </div>
            </>



        </>
    )
}

export default AdvanceEmployee